import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import {
  currentAppId,
  currentAppEntity,
  currentAppVersion,
  currentAppVersionEntities,
  currentAppDefinitionEntity,
  lifecycleErrorMessage as getLifecycleErrorMessage,
  lifecycleHasFailed,
  lifecycleHasFinished,
  lifecycleHasStarted,
} from 'app/developer-v3/selectors';
import {
  getAppVersionUrl,
  getCurrentBuildUrl,
  sortVersionObjects,
} from 'app/developer-v3/utils';

import NonEditableUI from './NonEditableUI';

import type { SemVer } from 'app/developer-v3/types/version';

const mapStateToProps = state => {
  const appEntity = currentAppEntity(state);
  const appVersion = currentAppVersion(state);
  const appDefinitionEntity = currentAppDefinitionEntity(state);
  const appId = currentAppId(state);
  const appVersionUrl = getAppVersionUrl(appId, appVersion);

  const currentBuildUrl = getCurrentBuildUrl(
    appVersionUrl,
    RouterSelectors.currentUrl(state)
  );

  const userCount = CliAppDefinition.selectors.userCount(appDefinitionEntity);

  const versionEntities = currentAppVersionEntities(state);
  const versions = versionEntities.map(versionEntity => ({
    isGUIIntegration: !!CliAppDefinition.selectors.isGUIIntegration(
      versionEntity
    ),
    version: CliAppDefinition.selectors.version(versionEntity),
  }));

  return {
    appId,
    appTitle: CliApp.selectors.title(appEntity) || 'App Name',
    appVersion,
    currentBuildUrl,
    isLifecycleRequestStarted: lifecycleHasStarted(state),
    isLifecycleRequestSuccessful: lifecycleHasFinished(state),
    isLifecycleRequestFailed: lifecycleHasFailed(state),
    lifecycleErrorMessage: getLifecycleErrorMessage(state),
    userCount,
    versions: sortVersionObjects(versions),
  };
};

const mapDispatchToProps = dispatch => ({
  viewAppVersion(appVersion: SemVer, postfix?: string) {
    dispatch(DeveloperActions.viewAppVersion(appVersion, postfix));
  },

  onClone(appId, fromVersion: SemVer, toVersion: SemVer) {
    dispatch(DeveloperActions.cloneAppVersion(appId, fromVersion, toVersion));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NonEditableUI);
